module.exports = __webpack_public_path__ + "static/media/logo191.ea9423c1.png";